import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-agreement-modal',
  templateUrl: './agreement-modal.component.html',
  styleUrls: ['./agreement-modal.component.scss'],
  standalone: false
})
export class AgreementModalComponent {
  @Input() appVersion: string = '1.0.0';
  accepted = false;

  constructor(private modalController: ModalController) {}

  toggleAccepted() {
    this.accepted = !this.accepted;
  }
  async continue() {
    if (!this.accepted) return;
    await this.modalController.dismiss({ accepted: true }, 'confirm');
  }
}